module.exports = __webpack_public_path__ + "img/Camila Ramos Garzon.ad16e5e2.jpg";